
<script>
import wechatPublic from './WechatPublic'

export default {
  extends: wechatPublic,
  name: 'wechatApplet',
  data () {
    return {
      theName: 'wechatApplet'
    }
  }
}
</script>
